import React from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import { useTranslation } from "react-i18next";

interface InviteDialogProps {
  open: boolean;
  onClose: () => void;
  inviteEmail: string;
  setInviteEmail: (email: string) => void;
  inviteRole: string;
  setInviteRole: (role: string) => void;
  onInvite: () => void;
  canManageManagers: boolean;
}

const InviteDialog: React.FC<InviteDialogProps> = ({
  open,
  onClose,
  inviteEmail,
  setInviteEmail,
  inviteRole,
  setInviteRole,
  onInvite,
  canManageManagers,
}) => {
  const { t } = useTranslation();

  const getRoleTranslation = (role: string) => {
    if (role === "owner") return t("preferences.enterprise.role.owner");
    if (role === "manager") return t("preferences.enterprise.role.manager");
    return t("preferences.enterprise.role.member");
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>{t("preferences.enterprise.inviteMember")}</DialogTitle>
      <DialogContent>
        <DialogContentText>{t("preferences.enterprise.inviteDescription")}</DialogContentText>
        <TextField
          autoFocus
          margin="dense"
          label={t("preferences.enterprise.invitation.email")}
          type="email"
          fullWidth
          variant="outlined"
          value={inviteEmail}
          onChange={(e) => setInviteEmail(e.target.value)}
          sx={{ mb: 2, mt: 2 }}
        />
        <FormControl fullWidth>
          <InputLabel id="role-select-label">{t("preferences.enterprise.invitation.role")}</InputLabel>
          <Select
            labelId="role-select-label"
            value={inviteRole}
            label={t("preferences.enterprise.invitation.role")}
            onChange={(e) => setInviteRole(e.target.value)}
          >
            <MenuItem value="member">{getRoleTranslation("member")}</MenuItem>
            <MenuItem value="manager" disabled={!canManageManagers}>
              {getRoleTranslation("manager")}
            </MenuItem>
            <MenuItem value="owner" disabled={!canManageManagers}>
              {getRoleTranslation("owner")}
            </MenuItem>
          </Select>
        </FormControl>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{t("common.cancel")}</Button>
        <Button onClick={onInvite} color="primary">
          {t("preferences.enterprise.invitation.invite")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default InviteDialog;
